<template>
    <v-app id="inspire">
        <v-content>
            <v-container
                fluid
                fill-height
            >
                <v-layout
                    align-center
                    justify-center
                >
                    <v-flex
                        xs12
                        sm8
                        md4
                    >
                        <v-card class="elevation-12">
                            <v-toolbar
                                dark
                                color="primary"
                            >
                                <v-toolbar-title>Recuperar contraseña</v-toolbar-title>
                                <v-spacer/>
                            </v-toolbar>
                            <v-card-text>
                                <v-alert
                                    :value="!valid_token"
                                    type="error"
                                    v-html="message"
                                />
                                <v-form>
                                    <v-text-field
                                        id="password"
                                        v-model="form.password"
                                        prepend-icon="lock"
                                        autocomplete="new-password"
                                        name="password"
                                        label="Contraseña"
                                        type="password"
                                    />
                                    <v-text-field
                                        id="password_confirmation"
                                        v-model="form.password_confirmation"
                                        prepend-icon="lock"
                                        autocomplete="new-password"
                                        name="password_confirmation"
                                        label="Confirmar contraseña"
                                        type="password"
                                    />
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                    color="gray"
                                    @click="$router.push({ name : 'login'})"
                                >
                                    Regresar
                                </v-btn>
                                <v-spacer/>
                                <v-btn
                                    v-if="valid_token"
                                    :loading="loading"
                                    color="primary"
                                    @click="iniciarSesion"
                                >
                                    Recuperar contraseña
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-snackbar
                    v-model="snackbar"
                    rigth
                    top
                    :color="snackbar_config.color"
                    :multi-line="snackbar_config.multi_line"
                    :timeout="snackbar_config.timeout"
                    :vertical="snackbar_config.mobile"
                >
                    <div v-html="snackbar_config.text_content"/>
                    <v-btn
                        dark
                        @click="snackbar = false"
                    >
                        Cerrar
                    </v-btn>
                </v-snackbar>
            </v-container>
        </v-content>
    </v-app>
</template>
<script>
    import axios from 'axios';

    export default {
        name: "FormResetPassword",
        data() {
            return {
                form: {
                    token: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                },
                message: '',
                valid_token: false,
                loading: false
            }
        },
        mounted() {
            let meta_json = document.querySelector('meta[name="data-json"');
            if (meta_json) {
                let data = JSON.parse(meta_json.getAttribute('content'));
                this.form.email = data.data.email;
                this.form.token = data.data.token;
                this.valid_token = data.success;
                this.message = data.message;
            }
        },
        methods: {
            iniciarSesion() {
                this.loading = true;
                axios.post('/password/custom-reset-password', this.form)
                    .then((response) => {
                        this.loading = false;
                        let {data} = response;
                        this.$router.push({
                            name: 'login'
                        });
                        this.snackbar_config.color = 'success';
                        this.snackbar_config.timeout = 6000;
                        this.snackbar = true;
                        this.snackbar_config.text_content = data.message;
                    })
                    .catch((error) => {
                        this.loading = false;
                        if (error.response) {
                            this.snackbar_config.color = 'error';
                            this.snackbar_config.timeout = 6000;
                            this.snackbar = true;
                            if (error.response.status === 401 && error.response.data.error) {
                                this.snackbar_config.text_content = error.response.data.message;
                            }

                            if (error.response.status === 422 && error.response.data.error) {
                                this.snackbar_config.text_content = error.response.data.message + '<br>';

                                if ((Object.getOwnPropertyNames(error.response.data.data)).length) {
                                    for (let item in error.response.data.data) {
                                        this.snackbar_config.text_content += (error.response.data.data[item]).join(',') + '<br>';
                                    }
                                }
                            }

                        }
                    })
            }
        }
    }
</script>

<style scoped>

</style>
